import { useTranslator } from '@translator-app/react';
import { CheckMailbox } from '~/app/auth/check-mailbox';
import { LoginForm } from '~/app/auth/login-form';
import classNames from 'classnames';
import React from 'react';

interface Props {
  variant?: 'default' | 'landing';
}

export const LoginPanel: React.FC<Props> = ({ variant = 'default' }) => {
  let { translate } = useTranslator();
  let [isCompleted, setIsCompleted] = React.useState(false);
  let [email, setEmail] = React.useState('');

  return (
    <div
      className={classNames('w-full max-w-md p-8', {
        'rounded border shadow-md bg-white': variant === 'default',
        'rounded-2xl bg-white border border-[#e2e1de] shadow-xl': variant === 'landing',
      })}
    >
      {isCompleted ? (
        <CheckMailbox email={email} />
      ) : (
        <LoginForm
          variant={variant}
          onComplete={(values) => {
            setIsCompleted(true);
            setEmail(values.email);
          }}
        />
      )}

      <div
        className={classNames('text-center mt-8 text-sm', {
          'text-blue-700 underline': variant === 'default',
          'text-gray-500 hover:text-blue-600 underline underline-offset-2': variant === 'landing',
        })}
      >
        <a href="/policies/terms-conditions">{translate('disclaimer.usingAgreeToTerms')}</a>
      </div>
    </div>
  );
};
